import useUtmQueryParams from 'hooks/useUtmQueryParams'

const UTM_MEDIUM_TO_DISABLE = new Set(['cpc', 'paidsocial'])
const EXCLUDED_CAMPAIGN_ID = '16499531278'

const useReferredByCondition = (): boolean => {
  const { utmMedium, utmCampaign } = useUtmQueryParams()

  return !(UTM_MEDIUM_TO_DISABLE.has(utmMedium) && utmCampaign !== EXCLUDED_CAMPAIGN_ID)
}

export default useReferredByCondition
